var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    {
      staticClass: "fill-height justify-center",
      attrs: { id: "login", tag: "section" }
    },
    [
      _c(
        "v-row",
        { attrs: { justify: "center" } },
        [
          _c(
            "v-card",
            { staticClass: "px-5 py-3", attrs: { width: "600" } },
            [
              _c(
                "v-card-title",
                { staticClass: "text-center clean" },
                [
                  _c("v-spacer"),
                  _vm._v(_vm._s(_vm.$t("export"))),
                  _c("v-spacer")
                ],
                1
              ),
              _c(
                "v-overlay",
                { staticClass: "waitoverlay", attrs: { value: _vm.loading } },
                [
                  _c("v-progress-circular", {
                    staticClass: "mr-4",
                    attrs: { indeterminate: "", size: "64" }
                  }),
                  _vm._v(" " + _vm._s(_vm.$t("global.loading")) + " ")
                ],
                1
              ),
              _c(
                "v-card-text",
                [
                  _c("date-range-picker", {
                    attrs: { "text-color": _vm.datePickerColor },
                    on: { datesChange: _vm.exportDataDatesChanged }
                  }),
                  _c("v-select", {
                    attrs: {
                      "item-text": "text",
                      items: _vm.scopeLocalised,
                      "item-value": "value",
                      label: _vm.$t("scope")
                    },
                    model: {
                      value: _vm.selectedScope,
                      callback: function($$v) {
                        _vm.selectedScope = $$v
                      },
                      expression: "selectedScope"
                    }
                  }),
                  !_vm.loading && _vm.selectedScope !== null
                    ? _c("v-select", {
                        attrs: {
                          items: _vm.keySelect,
                          "item-text": "text",
                          "item-value": "value",
                          label: _vm.selectedScope
                        },
                        model: {
                          value: _vm.key,
                          callback: function($$v) {
                            _vm.key = $$v
                          },
                          expression: "key"
                        }
                      })
                    : _vm._e(),
                  _c("v-text-field", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showKey,
                        expression: "showKey"
                      }
                    ],
                    attrs: { color: "secondary", label: _vm.$t("key") },
                    model: {
                      value: _vm.key,
                      callback: function($$v) {
                        _vm.key = $$v
                      },
                      expression: "key"
                    }
                  }),
                  _c("v-select", {
                    attrs: {
                      "item-text": "text",
                      items: _vm.formats,
                      "item-value": "value",
                      label: _vm.$t("format")
                    },
                    model: {
                      value: _vm.selectedFormat,
                      callback: function($$v) {
                        _vm.selectedFormat = $$v
                      },
                      expression: "selectedFormat"
                    }
                  }),
                  _vm.isSuperUser
                    ? _c("v-switch", {
                        attrs: {
                          disabled: _vm.disableAnonymiseButton,
                          label: _vm.$t("anonymise-data"),
                          inset: ""
                        },
                        model: {
                          value: _vm.anonymise,
                          callback: function($$v) {
                            _vm.anonymise = $$v
                          },
                          expression: "anonymise"
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _c(
                "v-card-actions",
                { staticClass: "text-center" },
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      staticClass: "center",
                      attrs: {
                        color: "blue",
                        disabled: _vm.disabledExportButton
                      },
                      on: { click: _vm.exportData }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("export")) + " ")]
                  ),
                  _c("v-spacer")
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-row",
        { attrs: { justify: "center" } },
        [
          _vm.error
            ? _c(
                "v-card",
                {
                  staticClass: "px-5 py-3 text-center",
                  attrs: { color: "red", width: "400" }
                },
                [_vm._v(" " + _vm._s(_vm.error)), _c("br")]
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "v-overlay",
        { attrs: { value: _vm.busy } },
        [
          _c("v-progress-circular", {
            attrs: { indeterminate: "", size: "64" }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }